export const setDocumentList = (state, data) => {
    state.existingDocs = data.sort((firstDoc, secondDoc) => firstDoc.name.localeCompare(secondDoc.name));
    state.ddlDocOptions = state.existingDocs.map(doc => ({
        label: doc.name,
        value: doc.id
    }));
    state.loadingDocs = false;
};

export const updateExistingDoc = (state, data) => {
    for (let i = 0; i < state.existingDocs.length; i++) {
        if (state.existingDocs[i].id === data.id) {
            state.existingDocs[i] = data;
            break;
        }
    }
};

export const updateDocumentList = (state, data) => {
    state.existingDocs = [data, ...state.existingDocs];
};

export const setDeleteDocument = (state, data) => {
    state.existingDocs.forEach((curr) => {
        if (curr.id === data) {
            const index = state.existingDocs.indexOf(curr);
            if (index > -1) {
                state.existingDocs.splice(index, 1);
            }
        }
    });
};

export const setCurrentTemplate = (state, reqResponse) => {
    state.currentTemplate = reqResponse;
    state.currentTemplate.document = state.currentTemplate.document === null ? "" : state.currentTemplate.document;
    state.loadingTemplates = false;
};

export const updateSelectedDoc = (state, data) => {
    state.selectedDoc = [];
    state.selectedDoc.push(data);
};

export const setAppUpdated = (state, data) => {
    state.appUpdated = data;
};

export const setCommitId = (state, data) => {
    state.commitId = data;
};
